import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://qbo6.api.xcelerateai-api.com" 
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const userEmail = localStorage.getItem('userEmail');

    if (userEmail && !config.url.includes('user_id=')) {
      const separator = config.url.includes('?') ? '&' : '?';
      config.url = `${config.url}${separator}user_id=${encodeURIComponent(userEmail)}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.error('Unauthorized request:', error.response?.data);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
  